<template>
  <div>
    <Purchase
      v-if="purchaseData"
      :data="purchaseData"
      :onDownload="onDownload"
    />
    <div v-if="data" class="container">
      <div :class="{ main: data.userId, 'main-m': !data.userId }">
        <div id="aPlayer"></div>
        <div
          v-if="
            data.videoId &&
              !data.purchased &&
              data.selling_price === 0 &&
              data.original_price > 0
          "
          class="vr-info-ctn"
        >
          <p class="price">
            <span v-if="data.discounts_before"
              >{{ data.discounts_before }}
            </span>
            <span class="unit">限时免费 </span>
            <span class="unit">￥</span>
            <span class="current">{{ data.selling_price }}</span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span class="origin">原价{{ data.original_price }}</span>
          </p>
          <p class="author">{{ data.sub_title }}</p>
        </div>
        <div
          v-bind:style="{
            width: screenWidth + 'px',
            maxWidth: screenWidth + 'px',
          }"
          v-if="data.content && !data.link_url"
          id="content"
          v-html="data.content"
        />
        <iframe
          v-if="data.content && data.link_url"
          :src="data.link_url"
          id="iframe"
          :width="screenWidth"
          :height="iframeHeight"
        />
        <ControlBar
          v-if="data.videos && data.videos.length > 0"
          :videos="data.videos"
          :onSection="onVideo"
        />
        <div class="intro" v-if="data.selling_introduction && !data.content">
          <div class="content-header">
            <p>课程介绍</p>
          </div>
          <div id="content" v-html="data.selling_introduction" />
        </div>
        <Recommendation
          v-if="data.recommendations && data.recommendations.length > 0"
          :type="data.type"
          :recommendations="data.recommendations"
          :onRecommendation="onRecommendation"
        />
        <Comment
          v-if="data.comments && data.comments.length > 0"
          :comments="data.comments"
        />
      </div>
      <div
        @click="onDownload"
        v-if="Object.keys(data).length !== 0 && !data.userId && !purchaseData"
        class="download-button"
      >
        下载培伴App
      </div>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string';
import polyvPlayer from 'polyvPlayer';
import Recommendation from './Recommendation';
import Comment from './Comment';
import Purchase from './Purchase';
import SafeAreaInsets from 'safe-area-insets';
import ControlBar from './ControlBar';

import BaseURL from '../static/config';

export default {
  name: 'Article',
  components: {
    Recommendation,
    Comment,
    Purchase,
    ControlBar,
  },
  data() {
    return {
      purchaseData: undefined,
      data: {},
      screenWidth: 0,
      iframeHeight: 0,
    };
  },
  mounted() {
    const searchString = location.hash.split('?')[1];
    const searchParams = queryString.parse(searchString);
    const { detailId, type, userId, fromApp, needFullScreen } = searchParams;
    const requestURL = BaseURL; //'http://172.16.0.35:7001/bethelapp/v2/';
    this.screenWidth = Math.min(window.innerWidth, 1024);
    this.iframeHeight = window.innerHeight - SafeAreaInsets.bottom - 40;

    this.axios
      .get(`${requestURL}${type}s/${detailId}`, {
        params: { from_app: true, user_id: userId },
      })
      .then((res) => {
        const {
          content,
          recommended_articles,
          comments,
          original_price,
          video_id,
          purchased,
          selling_price,
          selling_introduction,
          title,
          sub_title,
          cover_url,
          link_url,
          discounts_before,
          videos,
          vid,
        } = res.data;

        let videoId;

        if (video_id || vid) {
          videoId = video_id || vid;
        } else {
          videoId =
            videos && videos.length > 0 ? videos[0].video_id : undefined;
        }

        if (!purchased && selling_price > 0) {
          this.purchaseData = {
            selling_introduction,
            selling_price,
            title,
            sub_title,
            video_id: videoId,
            original_price,
            comments,
            cover_url,
            userId,
            videos,
          };
        } else {
          this.data = {
            videoId,
            content,
            recommendations: recommended_articles,
            comments,
            selling_introduction,
            type,
            userId,
            link_url,
            selling_price,
            original_price,
            sub_title,
            title,
            discounts_before,
            purchased,
            videos,
          };

          if (videoId) {
            this.createPlayer(videoId);
          }
        }
      })
      .catch((error) => {
        console.log('error.response.data.message', error);
      });

    window.onload = () => {
      window.addEventListener('message', ({ data }) => {
        if (typeof data === 'string') {
          this.comments = [...this.comments, JSON.parse(data)];
        }
      });
    };

    if (needFullScreen) {
      window.s2j_onFullScreen = (videoId) => {
        this.player.j2s_pauseVideo();
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              func: 'navigateToLandMode',
              start: this.player.j2s_getCurrentTime(),
              videoId,
            })
          );
        }
      };
    }

    document.getElementById('content').addEventListener('click', (event) => {
      if (!fromApp) {
        event.preventDefault();
        this.onDownload();
      }
    });
  },
  methods: {
    onVideo(vid) {
      this.player.changeVid({ vid });
    },

    onDownload() {
      if (this.isiOSSystem()) {
        window.location.href =
          'https://apps.apple.com/cn/app/bethelparent/id1237620244';
      } else {
        window.location.href =
          'http://content-pic2.oss-cn-shanghai.aliyuncs.com/android_version.apk';
      }
    },
    isiOSSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
        return false;
      }
      if (/android/i.test(userAgent)) {
        return false;
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true;
      }
      return false;
    },
    createPlayer(vid) {
      this.player = polyvPlayer({
        wrap: '#aPlayer',
        width: this.screenWidth,
        height: (this.screenWidth * 480) / 854,
        vid,
        forceH5: true,
        allowFullscreen: true,
      });
    },
    onRecommendation(recommendation) {
      const { _id, title, video_id } = recommendation;
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            func: 'onRecommendation',
            detailId: _id,
            navigationTitle: title,
            type: video_id ? 'video' : 'article',
          })
        );
      }
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  max-width: 1024px;
  background-color: #fff;
}

#content {
  padding: 15px 15px 10px 15px;
  box-sizing: border-box !important;
  text-align: justify !important;
  max-width: 1024px;
}

#iframe {
  background-color: #fff;
  text-align: justify !important;
  padding: 0 !important;
  border: none;
  overflow-x: hidden;
}

iframe:focus {
  outline: none;
}

#content >>> img {
  display: block;
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  padding: 0 !important;
  margin: 0 auto !important;
}

#content >>> * {
  max-width: 100% !important;
  word-break: break-all;
  box-sizing: border-box !important;
}

#content >>> video {
  max-width: 100% !important;
  word-break: break-all;
  pointer-events: all !important;
  box-sizing: border-box !important;
}

#content >>> a {
  text-decoration: none !important;
}

#content >>> ul {
  max-width: 100% !important;
  margin-left: 0 !important;
  list-style-position: initial !important;
  padding: 0 15px !important;
  box-sizing: border-box !important;
}

#content >>> p {
  max-width: 100% !important;
  line-height: 1.75 !important;
  box-sizing: border-box !important;
}

#content >>> li {
  max-width: 100% !important;
  margin: 5px 0 !important;
  box-sizing: border-box !important;
}

.main {
  padding: 0;
  margin: 0;
  max-width: 1024px;
}

.main-m {
  padding: 0;
  margin: 0;
  margin-bottom: calc(40px + env(safe-area-inset-bottom));
  margin-bottom: calc(40px + constant(safe-area-inset-bottom));
  max-width: 1024px;
}

p {
  margin: 0;
  padding: 0;
}

.download-button {
  position: fixed;
  height: 40px;
  width: inherit;
  max-width: 1024px;
  background-color: #49afad;
  text-align: center;
  color: white;
  line-height: 40px;
  bottom: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

/* header */
.vr-info-ctn {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
}

.price {
  font-size: 16px;
  color: #999;
}

.price > .current {
  font-size: 20px;
  color: #f24a4a;
  font-weight: 500;
}

.price > .unit {
  color: #f24a4a;
}

.price > .origin {
  text-decoration: #999 line-through;
}

.intro {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  background-color: #fff;
  width: 100%;
}

.content-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  border-bottom: #f5f5f5 solid 1px;
  background-color: #fff;
}

.content-header > p {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  width: 100%;
}

.video-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
}

.video-info > .title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  margin-top: 4px;
  text-align: justify;
}

.video-info > .author {
  font-size: 16px;
  color: #898989;
  margin-top: 6px;
}
</style>
